export const enum FavoritesCategory {
  SPORT = 'Sport',
  UNION = 'Union',
  TOURNAMENT = 'Tournament',
  STAGE = 'Stage',
  MATCH = 'Match',
}

export type FavoritesRequestData = {
  'category': FavoritesCategory;
  'categoryId': number;
};

